import getO365ShellShim from './getO365ShellShim';
export default function setShellButtonCustomBadgeCount(buttonId: string, badgeCount: number) {
    getO365ShellShim().Extensibility.SetCustomHeaderButtonBadgeValue(buttonId, badgeCount);
}
